import moment from 'moment-timezone';

interface IDateFormatResult {
  datetime: string;
  mskTimezone: string;
}

function dateFormat(input: string | Date | null | undefined, format?: string): IDateFormatResult {
  const m = moment.parseZone(input);
  const datetimeString = m.format(format);

  const utcOffset = m.utcOffset();
  const mskOffset = m.clone().tz('Europe/Moscow').utcOffset();
  const totalOffsetMinutes = utcOffset - mskOffset;

  const offsetHours = Math.floor(Math.abs(totalOffsetMinutes) / 60);
  const offsetMinutes = Math.abs(totalOffsetMinutes) % 60;
  const offsetSign = totalOffsetMinutes >= 0 ? '+' : '-';
  let mskTimezoneString = `МСК${offsetSign}${String(offsetHours).padStart(2, '0')}`;

  if (offsetMinutes !== 0) {
    mskTimezoneString += `:${String(offsetMinutes).padStart(2, '0')}`;
  }

  return {
    datetime: datetimeString,
    mskTimezone: mskTimezoneString,
  };
}

export default dateFormat;
